import {
  BookOpenText,
  Globe,
  Student,
  UsersThree,
} from "@phosphor-icons/react";

const adminRoles = [
  { name: "Account", key: "adminAccount", icon: UsersThree },
  { name: "CMS Landing Page", key: "adminCmsLandingpage", icon: Globe },
  { name: "Blog", key: "adminBlog", icon: BookOpenText },
  { name: "Course", key: "adminCourse", icon: Student },
];

export default adminRoles;
